import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from './components/Login';
import ForgotPassword from './components/ForgetPassword';
import "react-notifications/lib/notifications.css";
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import ResetPassword from './components/ResetPassword';
import Header from './components/Header';
import Sidebar2 from './components/Sidebar';
import { authRoutes, resetPasswordRoute } from './components/common';
import UserProfile from './components/userProfile/UserProfile';
import { AuthProvider } from './context/Context';
import { ROLES } from './routes';
import AdminDashboard from './components/admin/AdminDashboard';
import OnboardingRequests from './components/admin/OnboardingRequests';
import ChangeRequests from './components/admin/ChangeRequests';
import OnboardingViewRequest from './components/admin/OnboardingRequests/ViewRequest';
import ChangeViewRequest from './components/admin/ChangeRequests/ViewRequest';
import { Toaster } from 'react-hot-toast';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAuthRoute = authRoutes.includes(pathname) || pathname.startsWith(resetPasswordRoute);

  return (
    <>
      {!isAuthRoute && <Sidebar2 />}
      {!isAuthRoute && <Header />}
      <main className={`home-section ${isAuthRoute && '!w-full md:!w-auto '}`} style={isAuthRoute ? { left: 0 } : {}}>{children}</main>
      {/* {!isAuthRoute && <Footer />} */}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
      <Layout>
        <Routes>
        
        {/*Private Routes */}
        <Route path='/profile' element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_HEAD, ROLES.TEAM_HEAD, ROLES.MEMBER, ROLES.PERSONAL_USER, ROLES.COMPANY_MEMBER]}><UserProfile /></PrivateRoute>} />



          {/*Admin Routes */}
          <Route path='/admin/dashboard' element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><AdminDashboard /></PrivateRoute>} />
          <Route path='/admin/onboarding-requests' element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><OnboardingRequests /></PrivateRoute>} />
          <Route path='/admin/change-requests' element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><ChangeRequests /></PrivateRoute>} />
          <Route path='/admin/onboarding-requests/:id' element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><OnboardingViewRequest /></PrivateRoute>} />
          <Route path='/admin/change-requests/:id' element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><ChangeViewRequest /></PrivateRoute>} />



          {/* Public Routes */}
          <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password/:token" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="*" element={<PublicRoute><Login /></PublicRoute>} />
        </Routes>
      </Layout>
      <Toaster
        position="top-right"
        toastOptions={{
          animation: 'slide',
          className: 'custom-toast',
          style: {
            background: '#2A2F2E',
            color: '#FFFFFF',
          },
          success: {
            iconTheme: {
              primary: '#AEF468',
              secondary: '#000000',
            },
          },
        }}
      />
      </AuthProvider>
      
    </BrowserRouter>
  );
}

export default App;
